// extracted by mini-css-extract-plugin
module.exports = {"title":"widgets_title__1bfxi","img":"widgets_img__XUhky","staticImagesContainer":"widgets_staticImagesContainer__kVHbQ"};